import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  open(event) {
    event.stopPropagation()
    const modalId = event.currentTarget.getAttribute("data-modal-target")
    const modal = document.getElementById(modalId)
    if (modal) {
      modal.showModal()
    }
  }

  close(event) {
    event.stopPropagation()
    this.element.close()
  }

  connect() {
    this.element.addEventListener('click', (event) => {
      if (event.target === this.element) {
        event.stopPropagation()
        this.element.close()
      }
    })
  }
}
